import React, { useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import { advancedColors } from '../../theme'

export type RowAction = { label: string; onClick: () => void }

// `CardActionsMenu` with an accessible name, and nothing rendered when there are no actions.
const RowActionsMenu = ({ actions }: { actions: RowAction[] }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)

  if (actions.length === 0) {
    return null
  }

  return (
    <>
      <IconButton
        size="small"
        aria-label="More actions"
        onClick={(event) => {
          event.stopPropagation()
          setAnchor(event.currentTarget)
        }}
      >
        <MoreVertRoundedIcon fontSize="small" sx={{ color: advancedColors.inkFaint }} />
      </IconButton>
      {/* A portal still bubbles through React, so a backdrop click would toggle the row it sits in. */}
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(event) => event.stopPropagation()}
        // Above the tour overlay (modal + 1), so the row-actions step can show this menu.
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            onClick={(event) => {
              event.stopPropagation()
              setAnchor(null)
              action.onClick()
            }}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default RowActionsMenu
